import React from "react";
import Slider from "react-slick";
import "./LogoSlider.css";

const LogoSlider = () => {
  const settings = {
    // Slick Slider settings go here
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    variableWidth: true,
    speed: 380,
    autoplay: true,

    responsive: [
      {
        breakpoint: 600,
        settings: {
          centerMode: false,
          slidesToShow: 1,
        },
      },
    ],
  };

  const logos = [
    "./clients/adityabirla-logo.png",
    "./clients/max-logo.png",
    "./clients/OrientCement-logo.png",
    "./clients/iris-logo.png",
    "./clients/ambujacement-logo.png",
    "./clients/kalamandir-logo.png",
    "./clients/Apollo-Pharmacy-logo.jpeg",
    "./clients/govtTelanganaLogo.png",
    "./clients/nagarjuna-group-logo.jpeg",
    "./clients/SFA-logo.jpg",
    "./clients/shvlogo2-logo.png",
    "./clients/tata-logo.jpeg",
    "./clients/ramojifilmcity-logo.png",
    "./clients/shvlogo1-logo.jpg",
  ];

  return (
    <section className="LogoSlider light_bg">
      <div className="mainHeading">Our team clients</div>
      <p className="center">
        We did a great job with these companies, you can be next to work with!
      </p>
      <Slider {...settings}>
        {logos.map((logo, index) => (
          <div className="picPan" key={index}>
            <img className="center" src={logo} alt="" />
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default LogoSlider;
